import { navigate } from "../config/navigate";

// Links sent from owl (alert emails, onsite SMS) carry the target video's
// account as `?account=<id>` inside the hash route, e.g.
// `#/content/edit_video/123?account=45`, so the app can switch to it on load.
const PARAM = "account";

const splitHash = (hash: string) => {
  const route = hash.replace(/^#/, "");
  const i = route.indexOf("?");
  return i < 0
    ? { path: route, params: new URLSearchParams() }
    : { path: route.slice(0, i), params: new URLSearchParams(route.slice(i + 1)) };
};

export const getDeepLinkAccountId = (hash: string = window.location.hash): number | null => {
  const value = splitHash(hash).params.get(PARAM);
  const id = Number(value);
  return value && Number.isInteger(id) && id > 0 ? id : null;
};

export const clearDeepLinkAccountParam = (hash: string = window.location.hash) => {
  const { path, params } = splitHash(hash);
  if (!params.has(PARAM)) return;
  params.delete(PARAM);
  const query = params.toString();
  navigate(`${path || "/"}${query ? `?${query}` : ""}`, { replace: true });
};

// Deep-linked account (only if the user can access it), then the stored one,
// then the first account.
export const pickAccount = <T extends { id: number }>(
  accounts: T[],
  deepLinkId: number | null,
  storedId: number | null
): T => {
  return (
    accounts.find((a) => a.id === deepLinkId) ??
    accounts.find((a) => a.id === storedId) ??
    accounts[0]
  );
};
